module.exports = __webpack_public_path__ + "img/form.f3c1569a.png";